const configure = {
    state:{
        HOST: '/api',  //后台访问地址根目录
        IMG_HOST: 'https://ape-learn-imgs.oss-cn-hangzhou.aliyuncs.com',
        // HOST: 'http://192.168.1.46:8099',  //后台访问地址根目录
    },
    getters: {
              
    },
    mutations: {
        
    }
}

export default configure